"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeAudioLevel = void 0;
/**
 * While audio levels can go from 0-10, we find that ambient white noise is usually at 6 or more and
 * levels usually range from 6-10.
 * This function spreads that typical 6-10 range out to a 0-10 range for use by the audio indicator.
 */
const normalizeAudioLevel = (level) => level ? (level < 5 ? 0 : ((level - 4.5) * 2)) : 0;
exports.normalizeAudioLevel = normalizeAudioLevel;
//# sourceMappingURL=normalize_audio_level.js.map